import Vue from 'vue';
import { api } from "../../services/Api.js";

export function update_calendar_item({ state }, payload){

    // add token to payload
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    return new Promise((resolve)=>{

      api.post(school,"update_calendar_item.php",payload).then(
        ()=>{
          Vue.$toaster.toast("language.update_calendar_item_success");
          resolve(); // always resolve to add calendar item page
        }).catch(
        error=>{
          Vue.$toaster.toast("update_calendar error"+error);
          resolve(); // always resolve to add calendar item page
        })

    })
    
  }
